import { render } from "./ProductConfig.vue?vue&type=template&id=60a297f7"
import script from "./ProductConfig.vue?vue&type=script&lang=js"
export * from "./ProductConfig.vue?vue&type=script&lang=js"

import "./ProductConfig.vue?vue&type=style&index=0&id=60a297f7&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__